module.exports = __webpack_public_path__ + "assets/inactive.f4aa6869.svg";